import CompetitionApi from "../api/competitionApi";
import * as types from "./actionTypes";

function getAllCompetitionsStarted() {
  return { type: types.COMPETITIONS_GET_ALL_STARTED };
}
function getAllCompetitionsFulfilled(teams: any) {
  return { type: types.COMPETITIONS_GET_ALL_FULFILLED, payload: teams };
}
function getAllCompetitionsRejected(error: any) {
  return {
    type: types.COMPETITIONS_GET_ALL_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

export function getAllCompetitions() {
  return (dispatch: any) => {
    dispatch(getAllCompetitionsStarted());
    CompetitionApi.getAllCompetitions()
      .then((teams) => dispatch(getAllCompetitionsFulfilled(teams)))
      .catch((er) => dispatch(getAllCompetitionsRejected(er)));
  };
}
